"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductsBcgMatrixClass = exports["default"] = exports.BcgMatrixClass = void 0;

var _commons = require("@stktk/commons");

var _lodash = require("lodash");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var BcgMatrixClass = {
  DOG: "dog",
  QUESTION_MARK: "question_mark",
  CASH_COW: "cash_cow",
  STAR: "star"
};
exports.BcgMatrixClass = BcgMatrixClass;
var bcgMatrixClasses = [BcgMatrixClass.DOG, BcgMatrixClass.QUESTION_MARK, BcgMatrixClass.CASH_COW, BcgMatrixClass.STAR];

var _getProductsBcgMatrixClass = function getProductsBcgMatrixClass(_ref) {
  var productCost = _ref.productCost,
      avgProductCost = _ref.avgProductCost,
      salesMixPct = _ref.salesMixPct,
      avgSalesMixPct = _ref.avgSalesMixPct;
  return bcgMatrixClasses[2 * (productCost < avgProductCost) + (salesMixPct > avgSalesMixPct)];
};

exports.getProductsBcgMatrixClass = _getProductsBcgMatrixClass;

var SalesMixHelper = /*#__PURE__*/function () {
  function SalesMixHelper(_ref2) {
    var recipeHelper = _ref2.recipeHelper,
        _ref2$saleRecords = _ref2.saleRecords,
        saleRecords = _ref2$saleRecords === void 0 ? [] : _ref2$saleRecords;

    _classCallCheck(this, SalesMixHelper);

    this.recipeHelper = recipeHelper;
    this._saleRecords = saleRecords;
    this._excludedEntries = [];
    this.initialize({
      saleRecords: saleRecords
    });
  } // eslint-disable-next-line complexity


  _createClass(SalesMixHelper, [{
    key: "initialize",
    value: function initialize(_ref3) {
      var _this = this;

      var saleRecords = _ref3.saleRecords;
      this._entries = {};
      this._totals = {
        saleValue: {
          sum: null
        },
        salesMixPct: {
          avg: null,
          min: null,
          max: null
        },
        avgProductCost: {
          avg: null,
          min: null,
          max: null
        }
      };
      saleRecords.forEach(function (record) {
        var sku = record.sku,
            netSalePrice = record.netSalePrice,
            quantity = record.quantity;
        var skuId = sku.id;
        var amount = (0, _commons.getTotalRecordSkuNormalizedAmount)(record, sku);
        var totalSaleValue = quantity * netSalePrice;

        if (skuId in _this._entries) {
          var entry = _this._entries[skuId];
          entry.records.push(record);
          entry.totalSaleValue += totalSaleValue;
          entry.amount += amount;
        } else {
          _this._entries[skuId] = {
            records: [record],
            netPurchasePrice: _this.recipeHelper.isRecipe({
              skuId: skuId
            }) ? _this.recipeHelper.getPurchaseValue({
              skuId: skuId
            }) : (0, _commons.getSkuDetails)(sku, "domain").netPurchasePrice,
            totalSaleValue: totalSaleValue,
            amount: amount,
            sku: sku
          };
        }

        _this._totals.saleValue.sum += totalSaleValue;
      });
      var salesMixPcts = [];
      var avgProductCosts = [];
      var avgProfits = [];
      var minSalesMixPct = null,
          maxSalesMixPct = null,
          minAvgProductCost = null,
          maxAvgProductCost = null,
          minAvgProfit = null,
          maxAvgProfit = null;
      var ids = Object.keys(this._entries);

      if (ids.length) {
        minSalesMixPct = Number.MAX_SAFE_INTEGER;
        maxSalesMixPct = Number.MIN_SAFE_INTEGER;
        minAvgProductCost = Number.MAX_SAFE_INTEGER;
        maxAvgProductCost = Number.MIN_SAFE_INTEGER;
        minAvgProfit = Number.MAX_SAFE_INTEGER;
        maxAvgProfit = Number.MIN_SAFE_INTEGER;
      }

      for (var _i = 0, _ids = ids; _i < _ids.length; _i++) {
        var skuId = _ids[_i];
        var entry = this._entries[skuId];
        var amount = entry.amount,
            totalSaleValue = entry.totalSaleValue,
            netPurchasePrice = entry.netPurchasePrice;

        if (amount === 0 || totalSaleValue === 0) {
          this._excludedEntries.push(entry);
        } else {
          var avgProductCost = amount * netPurchasePrice / totalSaleValue;
          var avgProfit = (totalSaleValue - amount * netPurchasePrice) / amount; // if (totalSaleValue == 0) {
          //   console.error(entry);
          // }

          entry.avgProductCost = avgProductCost;
          entry.avgProfit = avgProfit;
          var salesMixPct = totalSaleValue / this._totals.saleValue.sum;
          entry.salesMixPct = salesMixPct;
          salesMixPcts.push(salesMixPct);
          minSalesMixPct = Math.min(salesMixPct, minSalesMixPct);
          maxSalesMixPct = Math.max(salesMixPct, maxSalesMixPct);
          avgProductCosts.push(avgProductCost);
          minAvgProductCost = Math.min(avgProductCost, minAvgProductCost);
          maxAvgProductCost = Math.max(avgProductCost, maxAvgProductCost);
          avgProfits.push(avgProfit);
          minAvgProfit = Math.min(avgProfit, minAvgProfit);
          maxAvgProfit = Math.max(avgProfit, maxAvgProfit); // console.log({ minSalesMixPct, maxSalesMixPct, minAvgProductCost, maxAvgProductCost, entry });
        }
      }

      this._totals.salesMixPct = {
        avg: (0, _lodash.mean)(salesMixPcts) || null,
        // in case no sale records
        min: minSalesMixPct,
        max: maxSalesMixPct
      };
      this._totals.avgProductCost = {
        avg: (0, _lodash.mean)(avgProductCosts) || null,
        // in case no sale records
        min: minAvgProductCost,
        max: maxAvgProductCost
      };
      this._totals.avgProfit = {
        avg: (0, _lodash.mean)(avgProfits) || null,
        // in case no sale records
        min: minAvgProfit,
        max: maxAvgProfit
      };
    }
  }, {
    key: "getExcludedRecords",
    value: function getExcludedRecords() {
      return (0, _lodash.flatten)(this._excludedEntries.map(function (entry) {
        return entry.records;
      }));
    }
  }, {
    key: "getEntry",
    value: function getEntry(_ref4) {
      var skuId = _ref4.skuId;
      return this._entries[skuId];
    }
  }, {
    key: "getEntries",
    value: function getEntries() {
      return (0, _lodash.map)(this._entries);
    }
  }, {
    key: "getTotals",
    value: function getTotals() {
      return this._totals;
    }
  }, {
    key: "getRecipeHelper",
    value: function getRecipeHelper() {
      return this.recipeHelper;
    }
  }, {
    key: "isProductsProductCostAboveAverage",
    value: function isProductsProductCostAboveAverage(_ref5) {
      var skuId = _ref5.skuId;
      return this._entries[skuId].avgProductCost > this._totals.avgProductCost.avg;
    }
  }, {
    key: "isProductsAverageSalesMixPctAboveAverage",
    value: function isProductsAverageSalesMixPctAboveAverage(_ref6) {
      var skuId = _ref6.skuId;
      return this._entries[skuId].salesMixPct > this._totals.salesMixPct.avg;
    }
  }, {
    key: "getProductsBcgMatrixClass",
    value: function getProductsBcgMatrixClass(_ref7) {
      var skuId = _ref7.skuId;
      if (!this._entries[skuId]) return null;
      var _this$_entries$skuId = this._entries[skuId],
          productCost = _this$_entries$skuId.avgProductCost,
          salesMixPct = _this$_entries$skuId.salesMixPct;
      var _this$_totals = this._totals,
          avgProductCost = _this$_totals.avgProductCost,
          avgSalesMixPct = _this$_totals.salesMixPct;
      return _getProductsBcgMatrixClass({
        productCost: productCost,
        avgProductCost: avgProductCost.avg,
        salesMixPct: salesMixPct,
        avgSalesMixPct: avgSalesMixPct.avg
      });
    }
  }]);

  return SalesMixHelper;
}();

exports["default"] = SalesMixHelper;